import React from 'react'
import PropTypes from 'prop-types'
import defaultTheme from 'tailwindcss/defaultTheme'

const Testimonial = ({className, color, title, children}) => {
  return (
    <div
      className={`${className} relative min-h-30 py-4 px-8 group`}
    >
      <span
        className="absolute top-0 left-0 w-12 h-12 transition-medium md:group-hover:opacity-0"
        style={{ boxShadow: `-6px -6px 0px ${defaultTheme.colors[color]['500']}` }}
      />
      <span
        className="absolute top-0 right-0 w-12 h-12 transition-medium md:group-hover:opacity-0"
        style={{ boxShadow: `6px -6px 0px ${defaultTheme.colors[color]['500']}` }}
      />
      <span
        className="absolute bottom-0 left-0 w-12 h-12 transition-medium md:group-hover:opacity-0"
        style={{ boxShadow: `-6px 6px 0px ${defaultTheme.colors[color]['500']}` }}
      />
      <span
        className="absolute bottom-0 right-0 w-12 h-12 transition-medium md:group-hover:opacity-0"
        style={{ boxShadow: `6px 6px 0px ${defaultTheme.colors[color]['500']}` }}
      />
      <div className="scale-95 md:group-hover:scale-100 transition-medium">
        <h4 className={`text-2xl mb-2 text-${color}-500`}>{title}</h4>
        <div className="font-normal leading-relaxed text-justify">{children}</div>
      </div>
    </div>
  )
}

Testimonial.defaultProps = {
  className: '',
  title: '[Title]',
  children: '[Content]',
  color: 'blue',
}

Testimonial.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
}

export default Testimonial
